import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { FC, useState, ReactNode } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Flex } from "../../Flex/flex.component";
import { FaChevronDown } from "react-icons/fa";
import { Button } from "../Button/button.scomponent";
import { Tag } from "../../Tag/tag.component";
import { normalizeOrderProductionStatus } from "../../../utils/normalizeProductionStatus";
import { ServiceOrderStageEnum, ServiceOrderStatusEnum } from "../../../Services/api/service-orders/service-order.interface";
import { normalizeFinancialStatusTitle } from "../../../utils/normalizeFinancialStatus";
import { normalizeOrderProductionStage } from "../../../utils/normalizeProductionStages";

interface IButtonStepMenuProps {
    options: {
        label: string;
        labelColor?: string;
        value: ServiceOrderStatusEnum | ServiceOrderStageEnum
        icon?: ReactNode;
        iconColor?: string;
    }[];
    type: 'status' | 'stage'
    mainIconColor?: string;
    initialLabel?: string;
    initialValue?: ServiceOrderStatusEnum | ServiceOrderStageEnum;
    onChange: ( data : { status: ServiceOrderStatusEnum | ServiceOrderStageEnum, productId: string }) => void;
    serviceOrderProductId: string
    readonly?: boolean
}

const ButtonStepMenu : FC<IButtonStepMenuProps> = ({ options, mainIconColor, initialLabel, initialValue, onChange, serviceOrderProductId, type, readonly }) => {
  const [step, setStep] = useState<string>(initialLabel || '')
  const [value, setValue] = useState<ServiceOrderStatusEnum | ServiceOrderStageEnum>(initialValue || ServiceOrderStatusEnum.INITIAL)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const statusStyle = type === 'status'
      ? normalizeOrderProductionStatus(value as ServiceOrderStatusEnum)
      : normalizeOrderProductionStage(value as ServiceOrderStageEnum);

    const stepContent = (
      <Flex
        alignItems='center'
        justifyContent='center'
        gap='10px'
        sx={{
          backgroundColor: statusStyle?.bgColor,
          width: '100%',
          padding: '10px 20px',
          borderRadius: '5px',
          flex: 1,
          cursor: readonly ? 'default' : undefined,
        }}
        width='100%'
      >
        <Typography
          fontSize={'14px'}
          color={statusStyle?.textColor}
          sx={{ width: '100%', flex: 1 }}
        >
          {step}
        </Typography>
        {!readonly && <FaChevronDown color={statusStyle?.textColor} />}
      </Flex>
    );
  
    return (
      <>
      {readonly ? (
        stepContent
      ) : (
        <Button variant='text' onClick={handleOpenMenu} sx={{ color: mainIconColor, height: '100%', width: '100%', flex: 1 }}>
          {stepContent}
        </Button>
      )}
       {!readonly && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
            {options.map((item, index) => (
                    <MenuItem 
                        key={index}
                        onClick={(e) => {
                            onChange({ status: item.value as ServiceOrderStatusEnum, productId: serviceOrderProductId })
                            handleCloseMenu()
                            setStep(item.label)
                            setValue(item.value as ServiceOrderStatusEnum)
                        }}
                        sx={{ color: item.labelColor }}
                    >
                        {item.icon && (
                            <span style={{ marginRight: '8px', display: 'flex', alignItems: 'center', color: item.iconColor }}>
                                {item.icon}
                            </span>
                        )}
                        {item.label}
                    </MenuItem>
            ))}
        </Menu>
      )}
      </>
    );
  };

  export { ButtonStepMenu }
